import { defineComponent, ref, useListeners, computed, inject } from 'vue';
import { useLocalizationSupport } from '../../composables/localization-support/index.js';
import { useStoreModule } from '../../composables/store-module/index.js';
import { useTableRow } from '../../composables/table-row/index.js';
import { usePagination } from '../../composables/pagination/index.js';
import UiModal from '../ui-modal/UiModal.vue.js';
import UiRenderNothing from '../ui-render-nothing/UiRenderNothing.vue.js';
import { watchlistCreateFactory } from '../watchlist-create/setup/index.js';
import { watchlistDeleteFactory } from '../watchlist-delete/setup/index.js';
import { watchlistEditFactory } from '../watchlist-edit/setup/index.js';
import HoistComponent from '../hoist-component/HoistComponent.vue.js';
import UiDropdownMenu from '../ui-dropdown-menu/UiDropdownMenu.vue.js';
import UiPagination from '../ui-pagination/UiPagination.vue.js';
import UiName from '../ui-name/UiName.vue.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WatchlistList",
  props: {
    locale: { type: null, required: true },
    itemsPerPage: { type: Number, required: false, default: 10 }
  },
  emits: ["store-error", "data-load", "watchlist-create", "watchlist-edit", "watchlist-delete", "table-row-key-click", "table-row-click"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const headers = [
      { key: "name", label: "watchlistList.name" },
      { key: "number-of-positions", label: "watchlistList.numberOfPositions" }
    ];
    const watchlistId = ref(null);
    const createModalToggle = ref(false);
    const editModalToggle = ref(false);
    const deleteModalToggle = ref(false);
    const watchlistCreateToggleButton = ref();
    const listeners = useListeners();
    const componentInputs = computed(() => ({
      language: props.locale,
      itemsPerPage: pagination.itemsPerPage.value,
      pageOffset: pagination.activePageOffset.value
    }));
    const showNoWatchlistsAlert = computed(() => {
      var _a;
      return ((_a = storeData.value) == null ? void 0 : _a.length) === 0 && !isLoadingStoreData.value && !hasStoreErrors.value;
    });
    const openCreateModal = () => {
      createModalToggle.value = true;
    };
    const closeCreateModal = () => {
      var _a;
      createModalToggle.value = false;
      (_a = watchlistCreateToggleButton.value) == null ? void 0 : _a.focus();
    };
    const onWatchlistCreate = (newWatchlistId) => {
      closeCreateModal();
      if (newWatchlistId) {
        watchlistId.value = newWatchlistId;
      }
      emits("watchlist-create");
    };
    const openEditModal = (id) => {
      watchlistId.value = id;
      editModalToggle.value = true;
    };
    const closeEditModal = () => {
      editModalToggle.value = false;
    };
    const onWatchlistEdit = () => {
      closeEditModal();
      emits("watchlist-edit");
    };
    const openDeleteModal = (id) => {
      watchlistId.value = id;
      deleteModalToggle.value = true;
    };
    const closeDeleteModal = () => {
      deleteModalToggle.value = false;
    };
    const onWatchlistDelete = () => {
      closeDeleteModal();
      watchlistId.value = null;
      emits("watchlist-delete");
    };
    const translator = inject("translator");
    const numberFormatter = inject("numberFormatter");
    const dateFormatter = inject("dateFormatter");
    const localizationSupport = useLocalizationSupport(props, { translator, numberFormatter, dateFormatter });
    const { translate, textFormat, numberFormat } = localizationSupport;
    const tableRow = useTableRow(listeners, emits);
    const { tableRowAttributes, hasTableRowClickListener, hasTableRowKeyClickListener, tableRowEvents, onTableRowKeyClick } = tableRow;
    const totalItems = computed(() => {
      var _a, _b;
      return (_b = (_a = storeMeta.value) == null ? void 0 : _a.pagination.total) != null ? _b : 0;
    });
    const pagination = usePagination(props, totalItems);
    const { totalPages, activePageOffset, onClickPagination } = pagination;
    const injectedStoreModule = inject("storeModule");
    const storeModule = useStoreModule({ storeModule: injectedStoreModule }, componentInputs, emits);
    const { storeData, storeMeta, isLoadingStoreData, hasStoreErrors } = storeModule;
    const WatchlistCreate = watchlistCreateFactory({
      translator,
      numberFormatter,
      dateFormatter,
      storeModule: (injectedStoreModule == null ? void 0 : injectedStoreModule.getDependencies) ? injectedStoreModule.getDependencies().watchlistCreate : void 0
    });
    const WatchlistDelete = watchlistDeleteFactory({
      translator,
      numberFormatter,
      dateFormatter,
      storeModule: (injectedStoreModule == null ? void 0 : injectedStoreModule.getDependencies) ? injectedStoreModule.getDependencies().watchlistDelete : void 0
    });
    const WatchlistEdit = watchlistEditFactory({
      translator,
      numberFormatter,
      dateFormatter,
      storeModule: (injectedStoreModule == null ? void 0 : injectedStoreModule.getDependencies) ? injectedStoreModule.getDependencies().watchlistEdit : void 0
    });
    return { __sfc: true, headers, watchlistId, createModalToggle, editModalToggle, deleteModalToggle, watchlistCreateToggleButton, props, emits, listeners, componentInputs, showNoWatchlistsAlert, openCreateModal, closeCreateModal, onWatchlistCreate, openEditModal, closeEditModal, onWatchlistEdit, openDeleteModal, closeDeleteModal, onWatchlistDelete, translator, numberFormatter, dateFormatter, localizationSupport, translate, textFormat, numberFormat, tableRow, tableRowAttributes, hasTableRowClickListener, hasTableRowKeyClickListener, tableRowEvents, onTableRowKeyClick, totalItems, pagination, totalPages, activePageOffset, onClickPagination, injectedStoreModule, storeModule, storeData, storeMeta, isLoadingStoreData, hasStoreErrors, WatchlistCreate, WatchlistDelete, WatchlistEdit, UiModal, UiRenderNothing, HoistComponent, UiDropdownMenu, UiPagination, UiName };
  }
});

export { _sfc_main as default };
